var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlbumParticipant(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "login",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_18781",
    "data-name": "Gruppe 18781",
    transform: "translate(-13 -13)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_18780",
    "data-name": "Gruppe 18780"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rechteck_24193",
    "data-name": "Rechteck 24193",
    width: 24,
    height: 24,
    transform: "translate(13 13)",
    fill: "none"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Gruppe_18782",
    "data-name": "Gruppe 18782",
    transform: "translate(-13 -13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_283707",
    "data-name": "Pfad 283707",
    d: "M24.5,23.075A4.575,4.575,0,1,0,19.925,18.5,4.581,4.581,0,0,0,24.5,23.075Zm0-8A3.425,3.425,0,1,1,21.075,18.5,3.428,3.428,0,0,1,24.5,15.075Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Pfad_283708",
    "data-name": "Pfad 283708",
    d: "M24.5,24.925A8.584,8.584,0,0,0,15.925,33.5a.575.575,0,1,0,1.15,0,7.425,7.425,0,0,1,14.85,0,.575.575,0,0,0,1.15,0A8.584,8.584,0,0,0,24.5,24.925Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlbumParticipant);
export default __webpack_public_path__ + "static/media/album_participant.b99c7497fa3c8858eb3bc1d07a0f297d.svg";
export { ForwardRef as ReactComponent };